import React from 'react';
import Button from './button';
import css from './css';

interface Props {
  positive?: string;
  negative?: string;
  disabled?: boolean;
  noPositive?: boolean;
  onSubmit?: (event: any) => void;
  onCancel: (event: any) => void;
}

const getPositiveButton = (props: Props) => {
  if (!props.noPositive) {
    return (
      <Button small onClick={props.onSubmit} disabled={props.disabled}>
        {props.positive}
      </Button>
    );
  }
};

export default function ButtonActions(props: Props) {
  const { negative, onCancel } = props;

  return (
    // @ts-ignore
    <div className={customStyles.buttonActions}>
      <Button quiet onClick={onCancel}>
        {negative}
      </Button>
      {getPositiveButton(props)}
    </div>
  );
}

const customStyles = css({
  buttonActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '10px 0',
  },
});
